export type CardTagSelectionTagType = {
  id: string;
  label: string;
};
